import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';
import { accountingsSettingsRoutes } from 'src/app/board/accounting/accounting-settings/accounting-settings-routes';

export const accountingRoutes: MenuInterface[] = [
    ...accountingsSettingsRoutes,
    {
        code: 'GestionConsultationMouvementComptableVUP_ViewModel',
        route: [
            {
                content: 'accounting/entries/accounting-analytics/list',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'GestionBlocagesClotureComptableVUP_ViewModel',
        route: [
            {
                content: 'accounting/entries/analytics-errors/list',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'GestionConsultationEcrituresRecetteDepense_ViewModel',
        route: [
            {
                content: 'accounting/entries/expenses/list',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'GestionConsultationEcriture_ViewModel',
        route: [
            {
                content: 'accounting/entries/consult/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionComptaFactureBeneficiaire_ViewModel',
        route: [
            {
                content: 'accounting/entries/invoice/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionComptaChequeAReceptionner_ViewModel',
        route: [
            {
                content: 'accounting/entries/cheques-receive/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionPlanCompte_ViewModel',
        route: [
            {
                content: 'accounting/printings/filters',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'GestionLettrageAuto_ViewModel',
        route: [
            {
                content: 'accounting/lettering/automated',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionLettrageComptable_ViewModel',
        route: [
            {
                content: 'accounting/lettering/manual/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionExportEcriture_ViewModel',
        route: [
            {
                content: 'accounting/imports-exports/export-entries/list',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'GestionSaisieEcrituresComptablesParModele_ViewModel',
        route: [
            {
                content: 'accounting/entries/edit',
                focus: 'empty',
            }, {primaryRoute: 'content', queryParams: {closeButton: 1}}
        ]
    },
    {
        code: 'GestionRemiseEnBanque_ViewModel',
        route: [
            {
                content: 'accounting/bank-deposit/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionReleveBancaire_ViewModel',
        route: [
            {
                content: 'accounting/reconciliation/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionParametrageBudget_ViewModel',
        route: [
            {
                content: 'accounting/budgets/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionClotureComptable_ViewModel',
        route: [
            {
                content: 'accounting/closing/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionHistoriqueEchéancier_ViewModel',
        route: [
            {
                content: 'accounting/schedule/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionComptaArreteCaisseVUP_ViewModel',
        route: [
            {
                content: 'accounting/cash-desk/cash-orders/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionRemiseEnCaisseCentraleVUP_ViewModel',
        route: [
            {
                content: 'accounting/cash-desk/central-cash/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionAbondementPMV_ViewModel',
        route: [
            {
                content: 'accounting/virtual-wallet/allocation/list',
                focus: 'empty',
            }, {primaryRoute: 'content', queryParams: {closeButton: 1}}
        ]
    },
    {
        code: 'GestionConsulterPMV_ViewModel',
        route: [
            {
                content: 'accounting/virtual-wallet/consultation/list',
                focus: 'empty',
            }, 'content'
        ]
    }


];
